import { IRegistration } from "@model/Authentication.model";
import * as actionTypes from "./UserRegistrationActionTypes";

const verifyUserAction =
  (userVerification: IRegistration) => (dispatch: any) => {
    try {
      dispatch({
        type: actionTypes.VERIFY_USER,
        payload: userVerification,
      });
    } catch (error) {
      return;
    }
  };

export { verifyUserAction };
